import { render, staticRenderFns } from "./DynamicHouse.vue?vue&type=template&id=471a89e9&scoped=true"
import script from "./DynamicHouse.vue?vue&type=script&lang=js"
export * from "./DynamicHouse.vue?vue&type=script&lang=js"
import style0 from "./DynamicHouse.vue?vue&type=style&index=0&id=471a89e9&prod&scoped=true&lang=css"
import style1 from "./DynamicHouse.vue?vue&type=style&index=1&id=471a89e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a89e9",
  null
  
)

export default component.exports